export default __webpack_public_path__ + "static/media/Project77MasterPlanNew.fc74fdcd.webp";